import React from 'react';

/**
 * Adaptador local con la firma de `SegmentedToggle` (@ole/react-library-agents).
 * Hoy renderiza `.seg > button[.on]` (Aura). Migración (OUW-72): `<SegmentedToggle … />`.
 */
export type PortalToggleItem = { value: string; label: string; icon?: React.ReactNode };

export type PortalToggleProps = {
  items: PortalToggleItem[];
  value: string;
  onChange: (value: string) => void;
  ariaLabel?: string;
  id?: string;
  fullWidth?: boolean;
};

export function PortalToggle({ items, value, onChange, ariaLabel, id }: PortalToggleProps) {
  return (
    <div className="seg" id={id} role="group" aria-label={ariaLabel}>
      {items.map((item) => (
        <button
          key={item.value}
          type="button"
          className={item.value === value ? 'on' : ''}
          aria-pressed={item.value === value}
          onClick={() => onChange(item.value)}
        >
          {item.icon}
          {item.label}
        </button>
      ))}
    </div>
  );
}
